import { useMutation, useQueryClient } from 'react-query';

import type { CopyOpeningScheduleRequest } from 'generated/index';

import { queryKeys, requests } from 'RestAPIs/rapini';

import showError from 'components/shared/showError';

/**
 * Copies a schedule and ends the original where the copy takes over, in one request, and answers the
 * copy's id. Wraps the generated request because the schedule to copy is only known when its row is
 * clicked.
 */
export const useCopyOpeningSchedule = (
  planUnitId: number,
  onCopied: (copyId: string) => void
) => {
  const queryClient = useQueryClient();

  return useMutation(
    ({
      openingScheduleId,
      copy
    }: {
      openingScheduleId: string;
      copy: CopyOpeningScheduleRequest;
    }) => requests.copyOpeningSchedule(copy, planUnitId, openingScheduleId),
    {
      onSuccess: (copyId) => {
        queryClient.invalidateQueries(queryKeys.getOpeningSchedules.name);
        queryClient.invalidateQueries(queryKeys.getEffectiveOpeningHours.name);
        onCopied(copyId);
      },
      onError: showError
    }
  );
};
